// Sessão de admin "guardada de lado" enquanto ele está logado como outro
// usuário (modo teste). Fica no mesmo sessionStorage, em chaves próprias --
// some sozinha ao fechar a aba, igual ao resto da sessão.

import { useCallback, useState } from "react";
import { StoredUser, getStoredUser, getToken, setStoredUser, setToken } from "./session";

const STASH_TOKEN_KEY = "admin_stash_token";
const STASH_USER_KEY = "admin_stash_user";

export function stashAdminSession(): void {
  const token = getToken();
  const user = getStoredUser();
  if (!token || !user) return;
  sessionStorage.setItem(STASH_TOKEN_KEY, token);
  sessionStorage.setItem(STASH_USER_KEY, JSON.stringify(user));
}

export function getAdminStash(): { token: string; user: StoredUser } | null {
  const token = sessionStorage.getItem(STASH_TOKEN_KEY);
  const rawUser = sessionStorage.getItem(STASH_USER_KEY);
  if (!token || !rawUser) return null;
  try {
    return { token, user: JSON.parse(rawUser) as StoredUser };
  } catch {
    return null;
  }
}

export function clearAdminStash(): void {
  sessionStorage.removeItem(STASH_TOKEN_KEY);
  sessionStorage.removeItem(STASH_USER_KEY);
}

/**
 * Estado de "modo teste" para a UI. A troca de sessão sempre recarrega a
 * página (ver Users.tsx / returnToAdmin), então basta ler o stash na
 * montagem -- não precisa reagir a mudanças em tempo real.
 */
export function useImpersonation() {
  const [stash] = useState(() => getAdminStash());
  const [currentUser] = useState(() => getStoredUser());

  const returnToAdmin = useCallback(() => {
    const s = getAdminStash();
    if (!s) return;
    setToken(s.token);
    setStoredUser(s.user);
    clearAdminStash();
    window.location.href = "/users";
  }, []);

  return {
    isImpersonating: !!stash,
    adminName: stash?.user.name ?? null,
    currentUserName: currentUser?.name ?? null,
    returnToAdmin,
  };
}
